import React, { useEffect, useState, useContext } from 'react';
import { ResponsiveContext, AccountContext, HistoryContext, useAsync, ModalContext } from '../../../hooks';
import axios from 'axios';
import Button from '../../controls/Button';
import StartDuel from '../../forms/StartDuel';
import StartContest from '../../forms/StartContest';
import Username from '../../user/Username';
import { dateString, pluralise } from '../../../functions';
import { Countdown } from '../../controls/Countdown';
import Ambigram from '../../ambigram/Ambigram';
import P from '../../controls/P';
import Btn from '../../controls/Btn';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';



export default function Command({ }) {
    let { desktop, device } = useContext(ResponsiveContext);
    let { user, checkPermissions } = useContext(AccountContext);
    let Modals = useContext(ModalContext);
    let { forceNavigate } = useContext(HistoryContext);
    
    let [width, setWidth] = useState(600);
    let [notEnough, setNotEnough] = useState(false);

    let [duel, setDuel] = useState();
    let [noDuel, setNoDuel] = useState();
    let [contest, setContest] = useState();
    let [noContest, setNoContest] = useState();

    useEffect(() => {
        if (device == 'phone') {
            setWidth(400);
        } else if (device == 'tablet') {
            setWidth(500);
        } else setWidth(600);
    }, [device])

    useAsync(async () => {
        let { data } = await axios.post('/api/command', { user });
        console.log(data);
        let {openDuel, currentContest} = data;
        if (openDuel && !openDuel.closed) {
            if (openDuel.pool) openDuel.pool.reverse();
            let { data } = await axios.post('/api/duel-pool', { user });
            if (data.length < 4) setNotEnough(true);
            setDuel(openDuel);
        } else setNoDuel(true);
        if (currentContest) {
            setContest(currentContest);
        } else setNoContest(true);
    },[])


    let [ended, setEnded] = useState(false);
    if (!user || !(user.admin || checkPermissions('Manage duels'))) return null;

    return <div className="Panel Command centrepanel">
        <div className="mb">
            <h1 className="lilmb">{contest?<>Current contest - <span>{contest.theme}!</span></>:"Contests"}</h1>
            {noContest ? <>
                <h4 className="lilmb">There is no contest currently running.</h4>
                <Button
                    onClick={() => {
                        Modals.create(StartContest, {
                            callback: async (post) => {
                                let { data } = await axios.post('/api/create-contest', { ...post, user });
                                if (data) {
                                    forceNavigate('/contest');
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        })
                    }}
                >Start a contest</Button>
            </> : contest ? <>
                <h4>Deadline: {dateString(contest.deathday)} 13:00 GMT</h4>
                <Countdown time={contest.deathday}/>
                <p>The current contest is in the {contest.theme=="Contest1"?'submission' : 'voting'} stage. <NavLink to='/contest'>Click here to check it out!</NavLink></p>
            </> : null}
        </div>
        <div>
            <h1 className="lilmb">{duel?<>Current duel - <span>{duel.word}!</span></>:"Duel arena"}</h1>
            {noDuel ? <>
                <h4 className="lilmb">There is no duel currently running.</h4>
                {notEnough ? <p>And there are not enough duel participants :(</p> : <Button onClick={() => {
                    Modals.create(StartDuel, {
                        callback: async (post) => {
                            let { data } = await axios.post('/api/create-duel', { ...post, user });
                            if (data) {
                                setNoDuel(false);
                                setDuel(data);
                                return true;
                            } else {
                                return false;
                            }
                        }
                    })
                }}
                >Start a duel</Button>}
            </> : duel ? <div>
                {duel.open?<>
                    {ended ? <h4>The submission period is over!</h4> : <h4>Deadline: {dateString(duel.deathday)} 13:00 GMT</h4>}
                    <Countdown time={duel.deathday} setEnded={setEnded} />
                </>:null}
                {duel.initialising ? <p>The duel will begin once 2 users have confirmed participation.</p> : null}
                {duel.participants ? <>
                    <h2>Participants:</h2>
                    <ol className="participants">
                        {duel.participants.map(p=><li className="participant" key={p.username}>
                            <Username username={p.username} /> {duel.initialising && !p.confirmed ? <i>Uncomfirmed {p.ignored > 0 ? ` (${p.ignored} strikes!)` : null}</i> : null}
                        </li>)}
                    </ol>
                </> : null}
                {duel.initialising ? <>
                    <h2>Pool:</h2>
                    <ol className="participants">
                        {duel.pool.map(p=><li className="participant" key={p}>
                            <Username username={p} />
                        </li>)}
                    </ol>
                </> : duel.open ? <>
                    {duel.participants ? duel.participants.map((participant, i) => <div className="PANEL" key={i}>
                        <h2 className="lilmb">{pluralise(participant.username)} entry</h2>
                        {!participant.entry ? <h4 className="mb">There is nothing...</h4> : <div className="entry bigmb">
                            <div className="entryLeft">
                                <Ambigram picture={participant.entry.picture} style={participant.entry.style} bounds={width} />
                            </div>
                            <div className="entryRight">
                                <div>
                                    <P>{participant.entry.message}</P>
                                </div>
                            </div>
                        </div>}

                        <h2 className="lilmb">{pluralise(participant.username)} progress pictures</h2>
                        {participant.progress.length == 0 ? <h4>There is nothing...</h4> :<div className="entries">
                            {participant.progress.map((entry, i) => <div className="entry">
                                <div className="entryLeft">
                                    <Ambigram picture={entry.picture} style={entry.style} bounds={width} />
                                </div>
                                <div className="entryRight">
                                    <div>
                                        <P>{entry.message}</P>
                                    </div>
                                </div>
                            </div>)}
                    
                        </div>}
                    </div>) : <p>You are participating in this duel. <NavLink to='/duel-arena'>Click here to check it out!</NavLink></p>}
                </> : null}
            </div> : null}
        </div>
    </div>
}